
import {
	ifAuthenticated,
	ifAuthenticatedOnline,
	canAccess,
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import Vehicle from '@/components/modules/vehicles/Vehicle'
import VehicleTabs from '@/components/modules/vehicles/VehicleTabs'
import VehiclesSettings from '@/components/modules/vehicles/settings/VehiclesSettings'
import VehicleExpirationsSettings from '@/components/modules/vehicles/settings/VehicleExpirationsSettings'

export const vehicles = [
	{
		path: '/vehicles',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/vehicles/',
					text: 'Veicoli',
				},
				{
					to: '/vehicles/expirations',
					text: 'Scadenze',
				},
			],
		},
		children: [
			{
				path: '/vehicles/',
				name: 'vehicles-index',
				meta: {
					title: 'Veicoli'
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'vehicles',
					actionIcon: 'mdi-car',
					title: 'Veicoli',
					styleClass: 'mb-offset'
				}
			},
			{
				path: 'expirations',
				name: 'vehicleexpirations-index',
				meta: {
					title: 'Scadenze Veicoli'
				},
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'vehicleexpiration', next) },
				component: Crud,
				props: {
					modelDef: 'vehicleexpirations',
					actionIcon: 'mdi-calendar-alert',
					title: 'Scadenze Veicoli',
					styleClass: 'mb-offset',
				},
			},
		],
	},
	{
		path: '/vehicles/create',
		name: 'vehicles-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'vehicles',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{
		path: '/vehicles/:id/edit',
		name: 'vehicles-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'vehicles',
			id: parseInt(route.params.id)
		}),
	},
	{
		path: '/vehicles/expirations/create',
		name: 'vehicleexpirations-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef: 'vehicleexpirations',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{
		path: '/vehicles/expirations/:id',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '',
					text: 'Scadenza',
				},
			],
		},
		children: [
			{
				path: '/vehicles/expirations/:id',
				name: 'vehicleexpirations-show',
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Scadenza Veicolo'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'vehicleexpirations',
					modelClass: 'vehicleexpiration',
					activities: true,
					fileuploader: true,
				}),
			},
		]
	},
	{
		path: '/vehicles/expirations/:id/edit',
		name: 'vehicleexpirations-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef: 'vehicleexpirations',
			id: parseInt(route.params.id)
		}),
	},
	{
		path: '/vehicles/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: VehicleTabs,
		props: (route) => ({
			id: parseInt(route.params.id)
		}),
		children: [
			{
				path: '',
				name: 'vehicles-show',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'vehicle', next) },
				component: Vehicle,
				meta: {
					title: 'Veicolo'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
				}),
			},
			{
				path: 'expirations',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'vehicleexpiration', next) },
				component: Crud,
				meta: {
					title: 'Scadenze Veicolo'
				},
				props: (route) => ({
					title: 'Scadenze',
					actionIcon: 'mdi-calendar-alert',
					modelDef: 'vehicleexpirations',
					subFilters: {vehicles: parseInt(route.params.id)},
					defaultInput: {expirable_id: parseInt(route.params.id)},
				}),
			},
			{
				path: 'tickets',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'trouble', next) },
				component: Crud,
				meta: {
					title: 'Ticket Veicolo'
				},
				props: (route) => ({
					title: 'Ticket associati',
					actionIcon: 'receipt',
					modelDef: 'troubles',
					subFilters: {vehicles: parseInt(route.params.id)},
				}),
			},
		]
	},
	{
		path: '/settingsvehicles/',
		name: 'settingsvehicles',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsvehicles',
					text: 'Veicoli',
				},
				{
					to: '/settingsvehicles/expirations',
					text: 'Scadenze',
				},
			],
		},
		children: [
			{
				path: '/settingsvehicles/',
				beforeEnter: ifAuthenticatedOnline,
				component: VehiclesSettings,
			},
			{
				path: 'expirations',
				beforeEnter: ifAuthenticatedOnline,
				component: VehicleExpirationsSettings,
			},
		],
	},
]
